import { Chip } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const PreviewFilterChip = styled(Chip)`
  padding: 0;
`
